import * as React from "react";
import { RES_URL } from "../../../config";
import { SCREEN_WIDTH } from "../../../constants";

export interface SelectionBarProps {
  className?: string;
  data: any;
  selectedIndex: number;
  closeSelection?: () => void;
  keyItem?: string;
  route?: string;
  isSelectionVisible?: boolean;
}

export interface SelectionBarState {
  transitionWidth: number;
  contentWidth: number;
  totalWidth: number;
}

declare var jQuery, dataLayer;

export class SelectionBar extends React.Component<
  SelectionBarProps,
  SelectionBarState
> {
  el: HTMLDivElement;
  listWrapEl: HTMLDivElement;
  liEl: HTMLLIElement;
  constructor(p: SelectionBarProps) {
    super(p);
    this.state = {
      transitionWidth: 0,
      contentWidth: 0,
      totalWidth: 0
    };
    window.addEventListener("resize", this.calculateContentWidth);
  }

  componentDidMount() {
    this.setState({
      totalWidth:
        this.liEl.getBoundingClientRect().width * this.props.data.length
    });
  }

  componentDidUpdate(
    prevProps: SelectionBarProps,
    prevState: SelectionBarState
  ) {
    if (this.props.selectedIndex !== prevProps.selectedIndex) {
      this.setState({
        transitionWidth: this.getTransitionWidth(this.props.selectedIndex)
      });
    }
  }

  getTransitionWidth = idx => {
    let liWidth = this.liEl.getBoundingClientRect().width;
    let xPos = liWidth * idx;
    let s = xPos + this.state.contentWidth;
    if (s > this.state.totalWidth) {
      return -(this.state.totalWidth - this.state.contentWidth);
    }
    xPos = xPos - (this.state.contentWidth / 2 - liWidth / 2);
    if (xPos < 0) {
      return 0;
    }
    return -xPos;
  };

  calculateContentWidth = () => {
    if (this.listWrapEl) {
      this.setState({
        contentWidth: this.listWrapEl.getBoundingClientRect().width
      });
    }
  };

  nextClick = () => {
    const transitionAmount = 100;
    let transitionWidth = this.state.transitionWidth - transitionAmount;
    if (
      Math.abs(transitionWidth) - transitionAmount >
      this.state.totalWidth - this.state.contentWidth
    ) {
      dataLayer.push({
        event: "clickEvent",
        clickEvent: this.state.transitionWidth
      });
      transitionWidth = this.state.transitionWidth;
    }
    this.setState({
      transitionWidth
    });
  };

  prevClick = () => {
    if (this.state.transitionWidth >= 0) {
      dataLayer.push({
        event: "clickEvent",
        clickEvent: this.state.transitionWidth
      });
      this.setState({
        transitionWidth: 0
      });
    } else {
      this.setState({
        transitionWidth: this.state.transitionWidth + 100
      });
    }
  };

  caluclateIconListStyle = () => {
    if (this.state.totalWidth > this.state.contentWidth) {
      return {
        transform: `translateX(${this.state.transitionWidth}px)`,
        width: this.state.totalWidth + "px"
      };
    } else {
      return {
        width: "100%",
        display: "flex",
        justifyContent: "center"
      };
    }
  };

  render() {
    let props = this.props,
      state = this.state,
      cls = this.props.className || "";

    return (
      <div className={"selection-bar " + cls} ref={e => (this.el = e)}>
        <div className="selection-bar__slider">
          {this.state.contentWidth < this.state.totalWidth && (
            <div
              className={
                this.state.transitionWidth === 0
                  ? "selection-bar__arrow-left disabled"
                  : "selection-bar__arrow-left"
              }
              onClick={this.prevClick}
            >
              <i className="icon-ip-ccslider-left" />
            </div>
          )}

          <div
            className="selection-bar__listwrap"
            ref={e => {
              this.listWrapEl = e;
              e &&
                state.contentWidth === 0 &&
                this.setState({
                  contentWidth: (e as HTMLDivElement).getBoundingClientRect()
                    .width
                });
            }}
          >
            <ul style={this.caluclateIconListStyle()}>
              {props.data.map((item, i) => {
                return (
                  <li
                    key={item.id}
                    ref={e => {
                      if (i == 0) this.liEl = e;
                    }}
                  >
                    <a href={"#/" + item.parent + "/" + item.id}>
                      <div className="selection-bar__item-label hide-on-mobile">
                        <p>{item.label}</p>
                      </div>
                      <div className="selection-bar__item">
                        <div
                          className={
                            this.props.selectedIndex === i
                              ? " image-icon selected"
                              : "image-icon"
                          }
                        >
                          <img src={`${RES_URL}img/icons/${item.imgSrc}`} />
                        </div>
                      </div>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          {this.state.contentWidth < this.state.totalWidth && (
            <div
              className={
                Math.abs(this.state.transitionWidth) >
                this.state.totalWidth - this.state.contentWidth
                  ? "selection-bar__arrow-right disabled"
                  : "selection-bar__arrow-right"
              }
              onClick={this.nextClick}
            >
              <i className="icon-ip-ccslider-right" />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/SelectionBar/SelectionBar.tsx